const HEADER_REQUEST_TOKEN_KEY = 'x-access-token';
const HEADER_CREDENTIAL_KEY = 'Authorization';
const HEADER_TOKEN_PREFIX = 'Bearer ';

export { HEADER_REQUEST_TOKEN_KEY, HEADER_CREDENTIAL_KEY, HEADER_TOKEN_PREFIX };
